import React, { Component } from 'react';

class BotMessageButtons extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <div className="message message-operator bots-quick-replies no-icon">
                <div className="button-wrapper">
                    {this.props.children}
                </div>
            </div>        
        )
    }
}
BotMessageButtons.propTypes = {
    children: React.propTypes.node
}
export default BotMessageButtons;